export default "__VITE_ASSET__a3387f2c__"